export const SET_LOCATION = 'carServicing/SET_LOCATION';
export const SET_VEHICLE = 'carServicing/SET_VEHICLE';
export const SET_MAIN_PACKAGE_DATA = 'carServicing/SET_MAIN_PACKAGE_DATA';
export const SET_MAIN_DEALER_LIST_DATA =
  'carServicing/SET_MAIN_DEALER_LIST_DATA';
export const SET_OTHER_DEALER_LIST_DATA =
  'carServicing/SET_OTHER_DEALER_LIST_DATA';
export const SET_BOOKING_STEP = 'carServicing/SET_BOOKING_STEP';
export const SET_KMS_DRIVEN = 'carServicing/SET_KMS_DRIVEN';
